import { fetchConToken, fetchSinToken } from '../helpers/fetch';

const AfiliadoService = {
    getData : (idAfiliado) => {
        return fetchSinToken(`Credenciales/TraerDatosPersonales/${idAfiliado}`)
    },
    getDataAfiliadoFromAfiliaciones:(idAfiliado)=>{
        return fetchConToken(`Afiliados/traerPorIdAfiliado/${idAfiliado}`)
    },
    cambiarDataAfiliado:(data)=>{
        return fetchConToken(`UsuariosAfiliados/actualizarperfil`,data,'PUT');
    },
    registro:(dni)=>{
        return fetchSinToken(`UsuariosAfiliados/${dni}`, {}, "POST")
    },
    olvidarPassword:(dni)=>{
        return fetchSinToken(`UsuariosAfiliados/passwordReset/${dni}`, {}, "PUT")
    },
    resetPassword:(data)=>{
        return fetchSinToken(`UsuariosAfiliados/cambioPassword`, data, "PUT")
    },
    cambiarPasswordUser:(data)=>{
        return fetchConToken(`UsuariosAfiliados/cambioPasswordPorIdUsuario`, data, "PUT")
    },
    selectDate:(nroDocumento, fecha)=>{
        return fetchConToken(`UsuariosAfiliados/ValidarFecNac/${nroDocumento}/${fecha}`, {}, "POST")
    },
    setEmail:(data)=>{
        return fetchConToken(`UsuariosAfiliados/actualizarEmailusuario`, data, "PUT")
    },
    enviarCredencialesAcceso:(idAfiliado)=>{
        return fetchConToken(`UsuariosAfiliados/enviarCredencialesAcceso/${idAfiliado}`, {}, "POST")
    },
    getReactivaciones: (idAfiliado) => {
        return fetchConToken(`Reactivaciones/${idAfiliado}`)
    },
    reactivacionPorLote: (data) => {
        return fetchConToken(`Reactivaciones/loteAfiliados`, data, "POST")
    },
    fetchValidarDatosPersonalesReactivacion: (idAfiliado) => {
        return fetchConToken(`Reactivaciones/validarDatosPersonales/${idAfiliado}`)
    },
    ingresarSeguimiento: (data) => {
        return fetchConToken(`Afiliados/seguimiento`, data, "POST")
    },
    ingresarSinFicha: (data) => {
        return fetchConToken(`Afiliados/sinFicha`, data, "POST")
    },
}

export {AfiliadoService as default}